import {useCallback, useEffect, useState} from "react";
import StorageService from "infrastructure/common/storage";
import {AppSettings} from "application/index";
import lookupUserInfo from "infrastructure/user/lookup-user-info";

export const usePrivateRoute = (props) => {
  const {
    enableGuestUser = true,
    isAuthenticated,
    onSignOutAction,
    invalidateUserAction,
    updateAuthStateAction
  } = props;

  const [isLoading, setLoading] = useState(true);

  const invalidateTicket = useCallback(async () => {
    if (!enableGuestUser) {
      // onSignOutAction(AppRouters.signIn);
      // toastHelper.info('Debe autenticarse para acceder a rutas seguras.');
      return;
    }

    invalidateUserAction();
  }, [enableGuestUser, onSignOutAction, invalidateUserAction]);

  useEffect(() => {
    const ticket = StorageService.getItem(AppSettings.ticketName);

    async function check() {
      // if user was recently authenticated, skip validation request until temporal token expires
      if (isAuthenticated) {
        return setLoading(false);
      }

      // if user was previously authenticated, but temporal token is expired
      // verify the user authentication and save on cache
      if (ticket) {
        setLoading(true);

        try {
          const user = await lookupUserInfo();

          if (user) {
            updateAuthStateAction({
              isAuthenticated: true,
              user,
            });

            return setLoading(false);
          }
        } catch (e) {

        }

        invalidateUserAction();
      }

      if (enableGuestUser) {
        invalidateUserAction();
        // if this route allows access for unauthenticated user
        // set loading to false and allow render of children view
        // @NOTE: make sure children view don't required user data
        return setLoading(false);
      }

      setLoading(false);
      // if the user is not authenticated and this route don't allow guest users
      // redirect to login route and alert the user with the reason of the redirection
      await invalidateTicket();
    }

    check();
  }, [isAuthenticated]);


  return {isLoading, enableGuestUser}
}
